/**
 * @ngdoc directive
 * @name ng.directive:vBannerChoice
 * @param vue
 */

export default (vue) => {
    if ( vue.el.parentNode.dataset.hasOwnProperty('position')) {
        vue.el.dataset.position = vue.el.parentNode.dataset.position;
    }
    vue.el.querySelector('div').innerHTML = 'Ad by ' + vue.el.parentNode.dataset.provider;
};